module.exports = "/_next/static/images/android_aplikace-50037680bf54549f9df0b6c45f8fc8cc.png";